module.exports = __webpack_public_path__ + "static/media/nevena-rapcan.99af89b8.jpg";